<template>
  <div class="source-wrap">
    <transition appear appear-to-class="animate__animated animate__fadeInLeft">
      <div class="left-content">
        <div class="main">
          <div class="view-box">
            <div class="steps-section">
              <div class="steps-header">
                <span class="steps-title">实训步骤完成</span>
                <span class="steps-badge">已完成</span>
              </div>
              <el-steps :active="4" finish-status="success" align-center>
                <el-step title="数据获取来源" description="已完成"></el-step>
                <el-step title="数据生成" description="已完成"></el-step>
                <el-step title="数据对比分析" description="已完成"></el-step>
                <el-step title="选定商品上架" description="已完成"></el-step>
              </el-steps>
            </div>
            <div class="title">
              <div class="icon">
                <img src="@/assets/image/result/2.png" alt="" />
              </div>
              <div class="name">
                <div class="txt">
                  实验总结
                </div>
                <div class="sub-txt">
                  experiment summary
                </div>
              </div>
            </div>
            <div class="content">
              <textarea v-model="content.result"> </textarea>
            </div>
          </div>
        </div>
        <div class="foot">
          <button v-print="printObj">
            <i class="el-icon-printer"></i>
            <span>
              打印报告
            </span>
          </button>
          <button @click="submit">
            <svg
              t="1623311651441"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3540"
              width="20"
              height="20"
            >
              <path
                d="M1003.4176 494.7968l-34.5088-34.5088-206.848-206.848c-9.5232-9.5232-24.9856-9.5232-34.5088 0l-34.5088 34.5088c-9.5232 9.5232-9.5232 24.9856 0 34.5088l34.5088 34.5088 106.496 106.2912h-479.232v97.4848h479.232L727.6544 667.136l-34.5088 34.5088c-9.5232 9.5232-9.5232 24.9856 0 34.5088l34.5088 34.5088c9.5232 9.5232 24.9856 9.5232 34.5088 0l34.5088-34.5088 172.3392-172.3392 34.5088-34.5088c9.4208-9.6256 9.4208-24.9856-0.1024-34.5088z m-380.5184 431.7184h-512V97.4848h512c13.4144 0 24.3712-10.9568 24.3712-24.3712V24.3712c0-13.4144-10.9568-24.3712-24.3712-24.3712h-512c-53.8624 0-97.4848 43.6224-97.4848 97.4848v828.928c0 53.8624 43.6224 97.4848 97.4848 97.4848h512c13.4144 0 24.3712-10.9568 24.3712-24.3712v-48.7424c0-13.4144-10.8544-24.2688-24.3712-24.2688z"
                p-id="3541"
              ></path>
            </svg>
            <span>
              提交实验
            </span>
          </button>
        </div>
      </div>
    </transition>
    <transition appear appear-to-class="animate__animated animate__fadeInRight">
      <div class="right-content">
        <div class="data-location">
          <div class="title">
            <div class="text">
              基本信息
            </div>
            <div class="subText">
              essential information
            </div>
          </div>
          <div class="content">
            <div class="item">
              <div class="icon">
                <img src="@/assets/image/home/user-user.png" alt="" />
              </div>
              <div class="label">
                <div class="txt">
                  姓名
                </div>
                <div class="sub-txt">
                  {{ student.realName }}
                </div>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <img src="@/assets/image/home/user-no.png" alt="" />
              </div>
              <div class="label">
                <div class="txt">
                  学号
                </div>
                <div class="sub-txt">
                  {{ student.studentNo }}
                </div>
              </div>
            </div>
            <div class="item">
              <div class="icon">
                <img src="@/assets/image/home/user-school.png" alt="" />
              </div>
              <div class="label">
                <div class="txt">
                  学校
                </div>
                <div class="sub-txt">
                  {{ student.schoolName }}
                </div>
              </div>
            </div>

            <div class="item">
              <div class="icon">
                <img src="@/assets/image/home/user-class.png" alt="" />
              </div>
              <div class="label">
                <div class="txt">
                  班级
                </div>
                <div class="sub-txt">
                  {{ student.className }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <table
      id="printSection"
      style="position: absolute;z-index: -999;left: 0;top: 0;"
    >
      <tr style="height: 200px">
        <td colspan="2">
          <div class="tit">
            <h1>实验报告</h1>
            <h3>电商选品虚拟仿真实验</h3>
            <div class="student">
              <span>姓名 : {{ student.realName }}</span>
              <span>学号 : {{ student.studentNo }}</span>
              <span>学校 : {{ student.schoolName }}</span>
              <span>班级 : {{ student.className }}</span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td style="width: 2rem">
          <div class="cell strong">
            实验产品
          </div>
        </td>
        <td>
          <div class="cell left">
            <div
              class="product-item"
              v-for="(item, index) in content.products"
              :key="index"
            >
              <div class="item-left">
                <div class="product-img">
                  <img :src="item.main" alt="" />
                </div>
              </div>
              <div class="item-right">
                <div class="item">
                  <div class="label">
                    国家
                  </div>
                  <div class="value">
                    {{ item.product.country }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">
                    标题
                  </div>
                  <div class="value">
                    {{ item.product.title }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">
                    价格
                  </div>
                  <div class="value">
                    {{ item.product.price }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">
                    库存
                  </div>
                  <div class="value">
                    {{ item.product.stock }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">
                    描述
                  </div>
                  <div class="value description">
                    {{ item.product.description }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="cell strong">
            实验总结
          </div>
        </td>
        <td>
          <div class="cell left">
            <pre v-html="content.result"></pre>
          </div>
        </td>
      </tr>
    </table>

    <stepDialog
      v-if="stepDialogStatus.show"
      :status="stepDialogStatus"
      @close="close"
    ></stepDialog>
  </div>
</template>

<script>
import stepDialog from "../../../components/stepDialog";

export default {
  components: {
    stepDialog,
  },
  data() {
    return {
      stepDialogStatus: {
        show: false,
        in: false,
        start: 10,
        end: 13,
        delayTime: 500,
      },
      content: {
        objective: " ",
        result: "",
        products: [],
      },
      student: {},
      loading: null,
      printObj: {
        id: "#printSection",
        popTitle: "电商选品虚拟仿真实验",
      },
    };
  },
  created() {
    // setTimeout(()=>{
    //   this.stepDialogStatus.show = true
    //   this.stepDialogStatus.in = true
    // },2000)
    this.$axios.get("/login/current").then((res) => {
      if (res.succeed) {
        this.student = res.student;
      }
    });
    this.getList();
  },
  watch: {
    "stepDialogStatus.show": function(newv) {
      if (newv) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "initial";
      }
    },
  },
  methods: {
    close() {
      this.stepDialogStatus.in = false;
      setTimeout(() => {
        this.stepDialogStatus.show = false;
      }, 1000);
    },
    getList() {
      this.$axios
        .post("/student/data/present/upload/template", {
          expId: this.$route.query.id,
          hasSort: true,
        })
        .then((res) => {
          if (res.succeed) {
            this.content.products = res.items.filter((item) => {
              return item.product && item.product.sort;
            });
          }
        });
    },
    submit() {
      if (!this.content.objective || !this.content.result) {
        this.$message({
          message: "请填写实验总结！",
          type: "error",
        });
        return false;
      }
      this.loading = this.$loading({
        fullscreen: true,
        body: true,
        lock: true,
      });

      this.$axios
        .post("/student/experiment/submit", {
          id: this.$route.query.id,
          content: JSON.stringify(this.content),
        })
        .then((res) => {
          setTimeout(() => {
            this.loading.close();
            if (res.succeed) {
              this.$message({
                message: res.message,
                type: "success",
              });

              this.$axios.post("/student/experiment/list").then((res) => {
                if (res.succeed) {
                  if (res.items[0].systemScore === 0) {
                    localStorage.setItem(
                      "schoolPlatformSubmitScore",
                      Math.floor(Math.random() * (22 - 1 + 1)) + 1
                    );
                  } else {
                    localStorage.setItem(
                      "schoolPlatformSubmitScore",
                      res.items[0].systemScore
                    );
                  }
                  document.querySelector("#schoolPlatformSubmitScore").click();
                  setTimeout(() => {
                    this.$router.push("/home");
                  }, 1000);
                }
              });
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          }, 1200);
        });
    },
  },
};
</script>

<style scoped lang="scss">
@mixin title {
  padding: 30px 30px 0 30px;
  margin-bottom: 10px;
  .text {
    font-size: 26px;
    font-weight: bold;
    line-height: 33px;
  }
  .subText {
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    color: #999999;
  }
}

button {
  width: 253px;
  height: 55px;
  background: linear-gradient(
    90deg,
    rgba(119, 166, 239, 0.97) 0%,
    #005be7 100%
  );
  box-shadow: 0 1px 4px rgba(119, 166, 239, 0.97);
  border-radius: 60px;
  position: relative;

  font-family: Microsoft YaHei UI, serif;
  font-size: 20px;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 26px;
    margin-right: 20px;
  }

  svg {
    margin-right: 20px;
    fill: white;
  }
}

.source-wrap {
  display: flex;

  .right-content {
    width: 360px;
    min-width: 360px;
    height: 722px;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    opacity: 1;
    border-radius: 12px;

    .data-location {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;

      .title {
        @include title;
        margin-bottom: 10px;
      }

      .content {
        padding: 30px;

        .item {
          padding: 20px;
          height: 98px;
          border: 1px solid #f1f1f1;
          border-radius: 12px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;

          .icon {
            width: 60px;
            height: 60px;
            margin-right: 30px;
          }

          .label {
            .txt {
              font-size: 14px;
              font-weight: 400;
              color: #999999;
              line-height: 20px;
            }

            .sub-txt {
              font-size: 18px;
              font-weight: bold;
              color: #666666;
              line-height: 26px;
            }
          }
        }
      }
    }
  }

  .left-content {
    margin-right: 40px;
    flex-grow: 1;
    flex-shrink: 1;
    height: 722px;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 12px;
    overflow: hidden;

    .main {
      display: flex;
      justify-content: center;
      padding: 0 60px;

      .view-box {
        padding-top: 8px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        .steps-section {
          border: 2px solid #f1f1f1;
          border-radius: 12px;
          padding: 16px 20px;
          margin-bottom: 18px;
          background: #ffffff;

          .steps-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;

            .steps-title {
              font-size: 18px;
              font-weight: bold;
              color: #333333;
            }

            .steps-badge {
              font-size: 12px;
              color: #ffffff;
              background: #67c23a;
              border-radius: 12px;
              padding: 2px 10px;
            }
          }

          .el-steps {
            padding: 0 8px;
          }
        }

        .title {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 18px;

          .icon {
            width: 90px;
            height: 90px;
            background: linear-gradient(142deg, #70a0eb 0%, #005be7 100%);
            box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 10px;
          }

          .name {
            text-align: center;

            .txt {
              font-size: 22px;
              font-weight: bold;
              line-height: 29px;
              color: #333333;
            }

            .sub-txt {
              font-size: 12px;
              font-weight: 400;
              line-height: 29px;
              color: #999999;
            }
          }
        }

        .content {
          textarea {
            resize: none;
            width: 100%;
            height: 280px;
            background: #ffffff;
            border: 2px solid #f1f1f1;
            opacity: 1;
            border-radius: 12px;
            padding: 18px;
            font-size: 14px;
            font-family: "Microsoft YaHei", sans-serif;
          }
        }
      }
    }

    .foot {
      margin-top: 30px;
      display: flex;
      justify-content: space-evenly;
    }
  }
}
</style>
<style lang="scss">
table#printSection {
  width: 100%;
  height: 100%;
  border: 1px solid #4e6d94;

  tr {
    width: 100%;

    td {
      border-right: 1px solid #000000;
      border-bottom: 1px solid #000000;
      vertical-align: middle;

      &:last-child {
        border-right: none;
      }

      div.tit {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #4e6d93;

        h1 {
          font-weight: bold;
          font-size: 34px;
          margin-bottom: 10px;
        }

        h3 {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 10px;
        }

        div.student {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          padding-left: 160px;
          box-sizing: border-box;

          span {
            text-align: left;
            line-height: 40px;
            font-size: 16px;
            width: 50%;
          }
        }
      }

      div.cell {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        &.left {
          display: block;
          padding: 20px;
        }

        &.strong {
          width: 100%;
          min-width: 100px;
          font-size: 18px;
          font-weight: bolder;
        }
      }

      textarea {
        display: none;
      }

      pre {
        padding: 10px 20px;
        font-size: 14px;
        font-family: "Microsoft YaHei", serif;
        line-height: 18px;
        white-space: pre-wrap;
        word-break: break-all;
        /*min-height: 400px;*/
      }

      div.product-item {
        border: 1px solid #d4d4d4;
        border-radius: 6px;
        overflow: hidden;
        width: 100%;
        margin: 0 1%;
        display: flex;
        margin-bottom: 6px;
        .item-left {
          border-right: 1px solid #d4d4d4;
          .product-img {
            width: 200px;
            height: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 200px;
              object-fit: contain;
            }
          }
        }
        .item-right {
          padding: 10px;
        }
        .item {
          display: flex;
          font-size: 18px;
          font-weight: bold;
          line-height: 26px;

          .label {
            width: 80px;
          }
          .value {
            font-weight: normal;
            &.description {
              font-size: 14px;
              width: calc(100% - 80px);
            }
          }
        }
      }
    }
  }
}
</style>
